import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'
import { CardExpansionHeader } from 'components/CardExpansion/CardExpansionHeader'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { ApprovalStatus } from 'generated/graphql'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { ChangeEvent, useMemo, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { UsefulLifeDetailContent } from '../UsefulLifeDetail/UsefulLifeDetailContent'
import { UsefulLifeAdjustmentDetailContent } from '../UsefulLifeDetail/UsefulLifeAdjustmentDetailContent'

interface ULListProps {
  filteredList: any[]
  listLoading: boolean
  listStatus: string
  userList: any[]
  fetchMore: Function
  setOriginalListing: Function
}

export const UsefulLifePostingList: React.FC<ULListProps> = ({
  filteredList,
  listLoading,
  listStatus,
  userList,
  fetchMore,
  setOriginalListing,
}) => {
  const { handlePermDisabled } = usePermissionChecker()
  const [postIDs, setPostIDs] = useState<Set<string>>(new Set())
  const [selectAll, setSelectAll] = useState(false)

  const sortedList = useMemo(() => {
    return filteredList?.sort(
      (a, b) =>
        Object.values(ApprovalStatus).indexOf(a?.ApprovalStatus) -
        Object.values(ApprovalStatus).indexOf(b?.ApprovalStatus)
    )
  }, [filteredList])

  const handleCheckBoxChange = (
    e: ChangeEvent<HTMLInputElement>,
    UsefulLifeID: string
  ) => {
    const newSet = new Set(postIDs)
    if (e.target.checked) {
      newSet.add(UsefulLifeID)
    } else {
      newSet.delete(UsefulLifeID)
      setSelectAll(false)
    }
    setPostIDs(newSet)
  }

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    setSelectAll(isChecked)

    const newSet = new Set(
      isChecked ? checkedFilteredList.map(el => el.UsefulLifeID) : []
    )
    setPostIDs(newSet)
  }

  const checkedFilteredList =
    filteredList && filteredList.length > 0 ? filteredList : []

  const onSubmitApprove = () => {
    console.log('Approving selected records:', Array.from(postIDs))
  }

  return (
    <>
      {listLoading && <Loading />}
      <ContentWrapper overflow>
        {listStatus === 'SUBMIT' && checkedFilteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              value=""
              color="primary"
              onChange={handleSelectAll}
              style={{
                marginLeft: '-5px',
                marginTop: '5px',
              }}
              checked={
                postIDs?.size > 0 &&
                postIDs?.size === checkedFilteredList?.length
              }
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {checkedFilteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={checkedFilteredList?.length}
              next={fetchMore}
              hasMore={true}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {checkedFilteredList.map((el, index) => (
                <CardExpansion
                  key={index}
                  summary={
                    <ListItem>
                      {listStatus === 'SUBMIT' && (
                        <FormControl
                          component="fieldset"
                          style={{
                            marginLeft: '10px',
                            marginRight: '-5px',
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                value=""
                                color="primary"
                                onChange={e =>
                                  handleCheckBoxChange(e, el?.UsefulLifeID)
                                }
                                style={{
                                  marginLeft: '-5px',
                                  marginTop: '5px',
                                }}
                                checked={postIDs.has(el?.UsefulLifeID)}
                              />
                            }
                            label=""
                          />
                        </FormControl>
                      )}
                      <ListItemText
                        primary={
                          <>
                            <span
                              className={`xsTitle flex-space`}
                              style={{ fontSize: '12px' }}
                            >
                              {el?.Name}
                            </span>
                            <span
                              className={`xsTitle`}
                              style={{ color: 'orange' }}
                            >
                              {el?.AssetNo}
                            </span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid container>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={6}>
                                  <span className="desc flex-space">
                                    <span>
                                      {`Useful Life: `}
                                      <span
                                        style={{
                                          textDecoration: 'line-through',
                                        }}
                                      >
                                        {`${amtNumStr(el?.InitialValue)}`}
                                      </span>
                                      <span style={{ color: 'orange' }}>
                                        &#10230;
                                      </span>
                                      <span
                                        style={{ color: 'limegreen' }}
                                      >{` ${amtNumStr(
                                        el?.UpdatedValue
                                      )}`}</span>
                                    </span>
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  style={{ textAlign: 'right' }}
                                >
                                  {!!el?.Date ? formatDate(el?.Date) : ''}
                                </Grid>
                              </Grid>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <span className="desc flex-space">
                                    {el?.Description}
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        }
                      />
                    </ListItem>
                  }
                >
                  <UsefulLifeDetailContent
                    listEl={el}
                    userList={userList}
                    listStatus={listStatus}
                    mode={'expansion'}
                  />

                  <CardExpansionHeader title="Useful Life Adjustment" />
                  <UsefulLifeAdjustmentDetailContent listAdjustment={el} />
                </CardExpansion>
              ))}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>

      {listStatus === 'SUBMIT' && (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => console.log('Open reject dialog'),
              color: 'secondary',
              props: {
                disabled: postIDs.size === 0,
              },
            },
            {
              name: 'Approve',
              onClick: onSubmitApprove,
              color: 'primary',
              props: {
                disabled: postIDs.size === 0,
              },
            },
          ]}
        />
      )}
    </>
  )
}
